
import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-issuecreditvoucherbrieflyofficerreport',
  templateUrl: './issuecreditvoucherbrieflyofficerreport.component.html',
  styleUrls: ['./issuecreditvoucherbrieflyofficerreport.component.scss'],
})
export class IssuecreditvoucherbrieflyofficerreportComponent implements OnInit {

  startDate: any;
  endDate: any;
  repName: any;
  issueName: any;
  issueDates: any;
  offRepName: any;
  reportType:any;

  advtOfficierbrieflyFormBeans: any;
  advtOfficierbrieflyTotal: number;
  constructor(
    private dialogRef: MatDialogRef<IssuecreditvoucherbrieflyofficerreportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) {
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.repName = data.repName;
    this.issueName = data.issuename;
    this.issueDates = data.issueDates;
    this.offRepName = data.offRepName;
    this.reportType=data.reportType;

    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
    console.log('Rep Name:', this.repName);
    console.log('Issue Name:', this.issueName);
    console.log('Issue Date:', this.issueDates);
    console.log('Off Rep Name:', this.offRepName);
   console.log('reportType:',this.reportType);
  }

 
    ngOnInit(): void {
      const req = {
   
        rep_name: this.repName,
        startDate: this.startDate,
        endDate: this.endDate,
        off_rep_name: this.offRepName,
        issue_name: this.issueName,
        issue_Date: this.issueDates
      
      };
    this.service.getissuesllerOfficerBriefly1(req).subscribe((data) => {
      this.advtOfficierbrieflyFormBeans = data;
      // this.OutStandingIDTotal = 0;
        // this.OutStandingIDNetAmtTotal = 0;
        // this.OutStandingIDUnPaidTotal = 0;
        // for (let data of this.advtOfficierbrieflyFormBeans) {
        //   for(let data1 of data.rep_data){
        //     this.OutStandingIDTotal += parseInt(data1.advt_amt_total) || 0;
        //     this.OutStandingIDNetAmtTotal += parseInt(data1.net_amt_total) || 0;
        //     this.OutStandingIDUnPaidTotal += parseInt(data1.unpaid_amt_total) || 0;
        //   } 
        // }
        this.advtOfficierbrieflyTotal = 0;
  
        // this.advtOfficierbrieflyTotal = 0;
        if(this.advtOfficierbrieflyFormBeans != null){  
     for (let data of this.advtOfficierbrieflyFormBeans) {
             for (let data1 of data.rep_data) {
                 this.advtOfficierbrieflyTotal += parseInt(data1.rcv_amt) || 0;
                
             }
         }
       }
    });
      (error) => {
        console.error('Error fetching briefly data:', error);
        this.toaster.error('Failed to load brief report', 'Error');
      }
    
  }
  PaymentadvtOffInDTotal(arg0: string, PaymentadvtOffInDTotal: any) {
    throw new Error('Method not implemented.');
  }

 exportExcel(fileName: string) {
   // Get the table element
   const element = document.getElementById('print-section');
   if (!element) {
     this.toaster.error('Table not found!');
     return;
   }
 
   // Use XLSX to convert the table to a worksheet
   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
 
   // Create a new workbook and append the worksheet
   const wb: XLSX.WorkBook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
   // Write workbook and save as Excel file
   XLSX.writeFile(wb, `${fileName}.xlsx`);
 }
}

